import React from 'react'

import './UserRatings.css'
const UserRatings = ({ rating }) => {
  let rating_box = '🟩';
  let blank_box = '⬜'
  if (rating < 2) {
    rating_box = '🟥';
  }
  else if (rating <4) {
    rating_box = '🟨';
  }
  let rating_score = [];
  for(let i = 1; i<rating; i++) {
    rating_score.push(rating_box)
  }
  for(let i = rating_score.length; i<5; i++) {
    rating_score.push(blank_box)
  }
  return (
    <div className='user-rating'>
      <span>{rating}</span>
      {rating_score.map((item,index) => <div key={index} className='scoreblock'>{item}</div>)}
      
    </div>
  )
}

export default UserRatings